import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


function HomeTop2({ data }) {
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 500 });
  }, []);

  useEffect(() => {
    let timeout;
    if (step < 5) {
      timeout = setTimeout(() => {
        setStep(step + 1);
      }, 400); // Delay for each step
    } else {
      timeout = setTimeout(() => {
        setStep(0); // Restart the animation
      }, 3000); // Hold for a few seconds before restarting
    }
    return () => clearTimeout(timeout);
  }, [step]);

  return (
    <div className="sectionBg">
      <div className="col-11 m-auto row align-items-center flex-column-reverse flex-lg-row">
        {/* LEFT CONTENT */}
        <div className="col-lg-7 col-12 text-start">
          {data.title.map((line, i) => (
            <p
              key={i}
              className={`fade-in display-1 fw-exbold ${step >= i + 1 ? "show" : ""
                }`}
            >
              {line.text}
              <span className="org">{line.highlight}</span>
            </p>
          ))}

          <p
            className={`fade-in fs-5 fw-r tJustify ${step >= 4 ? "show" : ""
              }`}
          >
            {data.paragraph}
          </p>

          <button
            className={`fade-in buttonEffect mb-3 ${step >= 5 ? "show" : ""
              }`}
            onClick={() => navigate(data.button.link)}
          >
            {data.button.label}
          </button>
        </div>

        {/* RIGHT IMAGE */}
        <div className="col-lg-5 col-12">
          <img
            src={data.image.src}
            data-aos="zoom-in"
            loading="lazy"
            style={{ width: "100%" }}
            alt=""
            crossOrigin="anonymous"
          />
        </div>
      </div>

      <style jsx>{`
        .fade-in {
          opacity: 0;
          transform: translateY(10px);
          transition: opacity 0.8s ease-in-out, transform 0.8s ease-in-out;
        }
        .fade-in.show {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </div>
  );
}

export default HomeTop2;
